class LyleProductGalleryExtension extends HTMLElement {
  #clickHandler = null;
  #scrollHandler = null;
  #indicatorClickHandler = null;
  #indicatorKeydownHandler = null;
  #scrollRevealTimer = null;
  #indicator = null;

  connectedCallback() {
    this.#clickHandler = (e) => {
      const btn = e.target.closest('[data-extension-trigger]');
      if (!btn) return;
      document.dispatchEvent(
        new CustomEvent('product-gallery:open', {
          detail: { mediaId: btn.dataset.mediaId },
        })
      );
    };
    this.addEventListener('click', this.#clickHandler);

    this.#indicator = this.querySelector('[data-scroll-indicator]');
    if (this.#indicator) {
      this.#setupScrollIndicator();
    }
  }

  disconnectedCallback() {
    if (this.#clickHandler) {
      this.removeEventListener('click', this.#clickHandler);
      this.#clickHandler = null;
    }
    if (this.#scrollHandler) {
      window.removeEventListener('scroll', this.#scrollHandler);
      this.#scrollHandler = null;
    }
    if (this.#scrollRevealTimer) {
      clearTimeout(this.#scrollRevealTimer);
      this.#scrollRevealTimer = null;
    }
    if (this.#indicatorClickHandler && this.#indicator) {
      this.#indicator.removeEventListener('click', this.#indicatorClickHandler);
      this.#indicatorClickHandler = null;
    }
    if (this.#indicatorKeydownHandler && this.#indicator) {
      this.#indicator.removeEventListener('keydown', this.#indicatorKeydownHandler);
      this.#indicatorKeydownHandler = null;
    }
    this.#indicator = null;
  }

  #setupScrollIndicator() {
    const reveal = () => {
      const rect = this.getBoundingClientRect();
      if (rect.bottom <= window.innerHeight) {
        this.#scrollRevealTimer = setTimeout(() => {
          this.#scrollRevealTimer = null;
          this.#indicator?.removeAttribute('inert');
          this.#indicator?.classList.add('is-visible');
        }, 150);
        window.removeEventListener('scroll', this.#scrollHandler);
        this.#scrollHandler = null;
      }
    };

    this.#scrollHandler = reveal;
    window.addEventListener('scroll', this.#scrollHandler, { passive: true });
    reveal();

    const scrollToNext = () => {
      const section = this.closest('.shopify-section');
      const next = section?.nextElementSibling;
      next?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    this.#indicatorClickHandler = scrollToNext;
    this.#indicator.addEventListener('click', this.#indicatorClickHandler);

    this.#indicatorKeydownHandler = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        scrollToNext();
      }
    };
    this.#indicator.addEventListener('keydown', this.#indicatorKeydownHandler);
  }
}

if (!customElements.get('lyle-product-gallery-extension')) {
  customElements.define('lyle-product-gallery-extension', LyleProductGalleryExtension);
}
